export default class StdOdemeEslestirmeRequestModel {
    StandartOdemeIdArray: number[];
}